module.exports = function() {
    const flexibleContents = document.querySelectorAll(".flexible-content");
    
    for (const flexibleContent of flexibleContents) {
        const tabButtons = flexibleContent.querySelector(".flexible-content__tab-buttons");
        const swipe = flexibleContent.querySelector(".flexible-content__tab-buttons__swipe");
        const tabContents = flexibleContent.querySelectorAll("[data-tab-content]");
        const bannerPictures = flexibleContent.querySelectorAll(".pb-\\[50\\%\\] > picture");
        const summaryPopup = flexibleContent.querySelector(".summary-popup");
        const summaryPopupWrapper = flexibleContent.querySelector(".summary-popup__wrapper");
        const summaryPopupCloseButtons = flexibleContent.querySelectorAll(".summary-popup__close-button");
        const summaryPopupButtons = flexibleContent.querySelectorAll("[data-summary-popup-index]");
        const summaryPopupContent = flexibleContent.querySelectorAll("[data-summary-popup-content]");
        
        tabButtons?.addEventListener("click", (e) => {
            const tabIndex = e.target?.dataset?.tabIndex;
            if ( !tabIndex ) return;

            switchTab(Number(tabIndex));
        })

        function switchTab(index) {
            if ( index === 0 ) {
                swipe.style.transform = `translateX(0px)`;
                tabContents[0].classList.remove("hidden");
                tabContents[1].classList.add("hidden");
            } else {
                swipe.style.transform = `translateX(calc(100% - 8px))`;
                tabContents[0].classList.add("hidden");
                tabContents[1].classList.remove("hidden");
            }

            bannerPictures.forEach((picture, i) => picture.classList.toggle("hidden", i !== index));
        }
        
        summaryPopupButtons?.forEach((button, index) => {
            button.addEventListener("click", () => {
                openSummaryPopup(index);
            })
        })
        
        summaryPopupCloseButtons?.forEach(button => {
            button.addEventListener("click", closeSummaryPopup);
        })
        
        function openSummaryPopup(index) {
            document.body.classList.add("overflow-hidden");
            summaryPopup.classList.remove("opacity-0", "invisible");

            summaryPopupContent.forEach(content => content.classList.add("hidden"));
            summaryPopupContent[index].classList.remove("hidden");
            
            setTimeout(() => {
                document.addEventListener("click", closeOutsideSummaryPopup);
            });
        }
        
        function closeSummaryPopup() {
            document.body.classList.remove("overflow-hidden");
            summaryPopup.classList.add("opacity-0", "invisible");
            document.removeEventListener("click", closeOutsideSummaryPopup);
        }
        
        function closeOutsideSummaryPopup(e) {
            if ( !summaryPopupWrapper?.contains(e.target) ) closeSummaryPopup();
        }
    }
};